import {assert} from 'Asserts';
import FolderDAOCache from 'file-browser/FolderDAOCache';
import FileStates from 'FileStates';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import StudyOverviewTabState from 'studies/workspace/tabs/StudyOverviewTabState';

import StudyDesignTabState from './workspace/tabs/StudyDesignTabState';

/**
 * Invalidate the given folder, so that it will refresh in the UI. This will also set the given folder
 * as the studies default. The studies default folder is used to determine an initial value for folder
 * selection when creating new studies.
 */
export function refreshStudyFolder(folderId: string): void {
  FolderDAOCache.invalidateFolderContents(folderId);
  FolderDefaults.set(FolderDefaultsKey.STUDIES, folderId);
}

/*
 * Navigates to the Overview tab for the given study.
 */
export async function navigateToStudyOverviewTab(studyId: string): Promise<void> {
  const studyFile = await FileStates.get().openFolderItem(studyId, {open: true});
  if (!studyFile) {
    // The user may have aborted opening the file.
    return;
  }
  const existingTab = studyFile.findTab(StudyOverviewTabState);
  assert(existingTab != null, 'Expected study to have a StudyOverviewTabState', {studyId});
  existingTab.set({active: true});
}

/*
 * Navigates to the Design tab for the given study.
 */
export async function navigateToStudyDesignTab(studyId: string): Promise<void> {
  const studyFile = await FileStates.get().openFolderItem(studyId, {open: true});
  if (!studyFile) {
    // The user may have aborted opening the file.
    return;
  }
  const existingTab = studyFile.findTab(StudyDesignTabState);
  assert(existingTab != null, 'Expected study to have a StudyDesignTabState', {studyId});
  existingTab.set({active: true});
}
